import { connect } from 'react-redux';
import CarouselComposer from '../presentations/Carousel/CarouselComposer';

import {
  changeCarouselIndex,
  setCarouselContentName,
  stopCarouselAutomode
} from '../actions/carousel';

import {
  getCarouselContentIndex,
  getCarouselChangeContentPause,
  getCarouselLoopState,
  getCarouselAutoplayState
  } from '../reducers/gui';

const mapStateToProps = ( state: any ) => ({
  contentIndex: getCarouselContentIndex( state ),
  loop: getCarouselLoopState( state ),
  autoplay: getCarouselAutoplayState( state ),
  changeContentPause: getCarouselChangeContentPause( state )
});

// listens for calls of functions in the presentation and calls a dispatch of the included function call result
// example:
//   setContentName(PARA) is called in the presentation
//   this is recognized in here
//   result of imported action setCarouselContentName (with param. PARA) is dispatched to the store
const mapDispatcherToProps = (dispatch:Function) => {
  return ({
    changeIndex: (index:number) => dispatch(changeCarouselIndex(index)),
    setContentName: (names:any) => dispatch(setCarouselContentName(names)),
    stopAutomode: () => dispatch(stopCarouselAutomode())
  });
};

const Carousel = connect(mapStateToProps, mapDispatcherToProps)(CarouselComposer);

export default Carousel;
